import styled from 'styled-components';
import { Theme } from '@pelando/components';
import EmptyState from '../../../../../components/EmptyState';

export const EmptyContainer = styled(EmptyState)`
  margin: 68px 0 46px;
  i {
    color: rgb(${Theme.colors.Brand});
  }
`;
